import { defineMessages } from 'react-intl-next';

export default defineMessages({
	errorStateHeader: {
		id: 'navigation-global-side-navigation.object-list-flyout.error-state.header',
		defaultMessage: "We couldn't fetch your items",
		description: 'Default heading for an error state in the object list flyout',
	},
	errorStateDescription: {
		id: 'navigation-global-side-navigation.object-list-flyout.error-state.description',
		defaultMessage: 'Refresh the page and try again.',
		description:
			'Default description for an error state in the object list flyout; shown if an error reason is not provided',
	},
});
